














































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { TriageObservationFile } from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "information-card": InformationCard,
  },
})
export default class MeasuredValuesView extends Vue {
  @Prop()
  advancedMode!: boolean;

  @Prop({ default: null })
  title!: string;

  @Prop({ default: null })
  observationFile!: TriageObservationFile;
}
